/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import * as Assets from '../api/Assets'
import * as Airtime from '../api/Airtime'

export const REQUEST_ASSET = 'REQUEST_ASSET'
export const RECEIVE_ASSET = 'RECEIVE_ASSET'
export const RECEIVE_ASSET_ERROR = 'RECEIVE_ASSET_ERROR'
export const CLEAR_ASSET = 'CLEAR_ASSET'

export const fetchAsset = (assetId, external) => dispatch => {
    dispatch(requestAsset());
    const apiPoint = external ? Airtime : Assets
    return apiPoint.fetchAsset(assetId).then(
        function (response) {
            dispatch(receiveAsset(response));
        }
    ).catch(err => {
        dispatch(receiveAssetError(err));
    })
}

const requestAsset = () => {
    return {
        type: REQUEST_ASSET,
    }
}

const receiveAsset = (asset) => {
    return {
        type: RECEIVE_ASSET,
        asset: asset,
    }
}

const receiveAssetError = (err) => {
    return {
        type: RECEIVE_ASSET_ERROR,
        error: err,
    }
}

export const clearAsset = () => {
    return {
        type: CLEAR_ASSET,
    }
}